<div style="width: 500px; height: 250px;" data-cy="fee-edit-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="fee-edit-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="fee-edit-header">
      <div class="section-header-title" data-cy="fee-edit-title">
        Edit Fee Schedule
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->

    <p style="margin-left: 15px;" data-cy="fee-edit-company-info">Created for Insurance Company: {{data.feeSchedule.OrganizationName}}</p>

    <div class="section-content" style="flex: 1; text-align: center;" data-cy="fee-edit-content">


      <div class="description-div" data-cy="fee-edit-description-div">


        <mat-form-field class="full-width" data-cy="fee-edit-name-field">
          <mat-label data-cy="fee-edit-name-label">Display Description:</mat-label>
          <input matInput
                 [(ngModel)]="feeScheduleName"
                 placeholder="Enter a description"
                 data-cy="fee-edit-name-input"/>
        </mat-form-field>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="fee-edit-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="close()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="fee-edit-cancel-button">Cancel</button>
      <button (click)="save()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="fee-edit-save-button">Ok</button>
    </div>
  </div>
</div>
